import { SET_EDITGROUP } from '../actions';

const groupedit = (state = [], action) => {
  switch (action.type) {
	case SET_EDITGROUP:
      return [...action.value];  
    default: return state;
  }
}

export default groupedit;
